import { useState, useEffect, useCallback, useRef } from 'react'
import { Button, Tag, Empty } from 'antd'
import { history } from '../../../redux/store'
import { SUPROUTE } from '../../../route'
import { getSupplierId, isResponseCodeSuccess } from '../../../tools/util'
import styles from './styles.module.scss'
import { GET_TODOLIST } from '../../../api/CommonApi'
import { TodoListSkeleton } from '../skeletons'
import emptyImage from '../../../assets/img/empty.png'
import { useAliveController } from 'react-activation'
import { TodoListRes } from '../../../api/CommonApi'
import dayjs from 'dayjs'
import { handleTodoNavigation } from '../../../pages/todoList/hooks'

export default function TodoList() {
  const { drop } = useAliveController()
  const [dataSource, setDataSource] = useState<TodoListRes[]>([])
  const [loading, setLoading] = useState(false)
  const [loadingMore, setLoadingMore] = useState(false)
  const [pageNo, setPageNo] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const [initialLoading, setInitialLoading] = useState(true)
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const pageSize = 15

  const getTodoList = useCallback(
    async (page: number = 1, isLoadMore: boolean = false) => {
      if (isLoadMore) {
        setLoadingMore(true)
      } else {
        setLoading(true)
      }
      const res = await GET_TODOLIST({
        supplierId: getSupplierId(),
        pageNo: page,
        pageSize: pageSize,
        siftTab: '1',
      })
      if (isResponseCodeSuccess(res.code)) {
        const list = res.data?.content || []
        const totalElements = res.data?.totalElements || res.data?.total || 0

        if (page === 1) {
          setDataSource(list as TodoListRes[])
          setInitialLoading(false)
          // 判断是否还有更多数据
          if (totalElements > 0) {
            setHasMore(list.length < totalElements)
          } else {
            setHasMore(list.length === pageSize)
          }
        } else {
          // 使用函数式更新来获取最新的dataSource长度，避免闭包问题
          setDataSource((prev) => {
            const newData = [...prev, ...(list as TodoListRes[])]
            // 判断是否还有更多数据
            if (totalElements > 0) {
              setHasMore(newData.length < totalElements)
            } else {
              setHasMore(list.length === pageSize)
            }
            return newData
          })
        }
        setPageNo(page)
      }
      setLoading(false)
      setLoadingMore(false)
    },
    [],
  )
  useEffect(() => {
    getTodoList(1)
  }, [getTodoList])

  const handleScroll = useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      const target = e.currentTarget
      const { scrollHeight, scrollTop, clientHeight } = target
      const scrollBottom = scrollHeight - scrollTop - clientHeight

      // 滚动到底部时加载下一页（距离底部50px时触发）
      if (
        scrollBottom <= 50 &&
        !loading &&
        !loadingMore &&
        hasMore &&
        !initialLoading
      ) {
        getTodoList(pageNo + 1, true)
      }
    },
    [loading, loadingMore, hasMore, initialLoading, pageNo, getTodoList],
  )

  const handleProcess = async (item: TodoListRes) => {
    await handleTodoNavigation(item, drop)
  }

  const getUrgentTag = (status: string) => {
    if (status === '2') {
      return <Tag className={styles.urgentTag}>紧急</Tag>
    }
    return null
  }

  const getStatusTag = (status: string) => {
    switch (status) {
      case '1':
        return <Tag className={styles.statusTag}>待处理</Tag>
      case '2':
        return <Tag className={styles.urgentTag}>逾期</Tag>
      case '3':
        return <Tag className={styles.statusTag}>已完成</Tag>
      default:
        return null
    }
  }
  const handleViewAll = () => {
    history.push({
      pathname: `${SUPROUTE}/todoBusiness`,
    })
  }

  // 首次加载时显示骨架屏
  if (initialLoading) {
    return <TodoListSkeleton />
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.title}>待办事项清单</span>
        <span className="btn-link" onClick={handleViewAll}>
          查看全部 &gt;&gt;
        </span>
      </div>
      <div
        ref={scrollContainerRef}
        className={styles.content}
        onScroll={handleScroll}
      >
        {dataSource.length === 0 ? (
          <div className={styles.emptyWrapper}>
            <Empty
              image={emptyImage}
              description="工作都完成了~非常棒哦"
              imageStyle={{
                width: '200px',
                height: '200px',
              }}
            />
          </div>
        ) : (
          <>
            <div className={styles.list}>
              {dataSource.map((item) => (
                <div key={item.id} className={styles.item}>
                  <div className={styles.itemLeft}>
                    <div
                      className={styles.taskName}
                      onClick={() => handleProcess(item)}
                    >
                      {item.title}
                    </div>
                    <div className={styles.itemMeta}>
                      <span>创建人{item.creatorName}</span>
                      <span className={styles.separator}>·</span>
                      <span>
                        截止日期:
                        {item.deadlineTime
                          ? dayjs(item.deadlineTime).format('YYYY-MM-DD')
                          : ''}
                      </span>
                      <span>
                        创建日期:
                        {item.createdTime
                          ? dayjs(item.createdTime).format('YYYY-MM-DD')
                          : ''}
                      </span>
                    </div>
                  </div>
                  <div className={styles.itemRight}>
                    {getUrgentTag(item.priority)}
                    {getStatusTag(item.status)}
                    <Button
                      type="primary"
                      size="large"
                      className={styles.actionBtn}
                      onClick={() => handleProcess(item)}
                    >
                      处理
                    </Button>
                  </div>
                </div>
              ))}
            </div>
            {loadingMore && (
              <div className={styles.loadingMore}>
                <span>加载中...</span>
              </div>
            )}
            {!hasMore && dataSource.length > 0 && (
              <div className={styles.noMore}>
                <span>没有更多数据了</span>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}
import { useState, useEffect, useCallback, useRef } from 'react'
import { Button, Tag, Empty } from 'antd'
import { history } from '../../../redux/store'
import { SUPROUTE } from '../../../route'
import { getSupplierId, isResponseCodeSuccess } from '../../../tools/util'
import styles from './styles.module.scss'
import { GET_TODOLIST } from '../../../api/CommonApi'
import { TodoListSkeleton } from '../skeletons'
import emptyImage from '../../../assets/img/empty.png'
import { useAliveController } from 'react-activation'
import { TodoListRes } from '../../../api/CommonApi'
import dayjs from 'dayjs'
import { handleTodoNavigation } from '../../../pages/todoList/hooks'

export default function TodoList() {
  const { drop } = useAliveController()
  const [dataSource, setDataSource] = useState<TodoListRes[]>([])
  const [loading, setLoading] = useState(false)
  const [loadingMore, setLoadingMore] = useState(false)
  const [pageNo, setPageNo] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const [initialLoading, setInitialLoading] = useState(true)
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const pageSize = 15

  const getTodoList = useCallback(
    async (page: number = 1, isLoadMore: boolean = false) => {
      if (isLoadMore) {
        setLoadingMore(true)
      } else {
        setLoading(true)
      }
      const res = await GET_TODOLIST({
        supplierId: getSupplierId(),
        pageNo: page,
        pageSize: pageSize,
        siftTab: '1',
      })
      if (isResponseCodeSuccess(res.code)) {
        const list = res.data?.content || []
        const totalElements = res.data?.totalElements || res.data?.total || 0

        if (page === 1) {
          setDataSource(list as TodoListRes[])
          setInitialLoading(false)
          // 判断是否还有更多数据
          if (totalElements > 0) {
            setHasMore(list.length < totalElements)
          } else {
            setHasMore(list.length === pageSize)
          }
        } else {
          // 使用函数式更新来获取最新的dataSource长度，避免闭包问题
          setDataSource((prev) => {
            const newData = [...prev, ...(list as TodoListRes[])]
            // 判断是否还有更多数据
            if (totalElements > 0) {
              setHasMore(newData.length < totalElements)
            } else {
              setHasMore(list.length === pageSize)
            }
            return newData
          })
        }
        setPageNo(page)
      }
      setLoading(false)
      setLoadingMore(false)
    },
    [],
  )
  useEffect(() => {
    getTodoList(1)
  }, [getTodoList])

  const handleScroll = useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      const target = e.currentTarget
      const { scrollHeight, scrollTop, clientHeight } = target
      const scrollBottom = scrollHeight - scrollTop - clientHeight

      // 滚动到底部时加载下一页（距离底部50px时触发）
      if (
        scrollBottom <= 50 &&
        !loading &&
        !loadingMore &&
        hasMore &&
        !initialLoading
      ) {
        getTodoList(pageNo + 1, true)
      }
    },
    [loading, loadingMore, hasMore, initialLoading, pageNo, getTodoList],
  )

  const handleProcess = async (item: TodoListRes) => {
    await handleTodoNavigation(item, drop)
  }

  const getUrgentTag = (status: string) => {
    if (status === '2') {
      return <Tag className={styles.urgentTag}>紧急</Tag>
    }
    return null
  }

  const getStatusTag = (status: string) => {
    switch (status) {
      case '1':
        return <Tag className={styles.statusTag}>待处理</Tag>
      case '2':
        return <Tag className={styles.urgentTag}>逾期</Tag>
      case '3':
        return <Tag className={styles.statusTag}>已完成</Tag>
      default:
        return null
    }
  }
  const handleViewAll = () => {
    history.push({
      pathname: `${SUPROUTE}/todoBusiness`,
    })
  }

  // 首次加载时显示骨架屏
  if (initialLoading) {
    return <TodoListSkeleton />
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.title}>待办事项清单</span>
        <span className="btn-link" onClick={handleViewAll}>
          查看全部 &gt;&gt;
        </span>
      </div>
      <div
        ref={scrollContainerRef}
        className={styles.content}
        onScroll={handleScroll}
      >
        {dataSource.length === 0 ? (
          <div className={styles.emptyWrapper}>
            <Empty
              image={emptyImage}
              description="工作都完成了~非常棒哦"
              imageStyle={{
                width: '200px',
                height: '200px',
              }}
            />
          </div>
        ) : (
          <>
            <div className={styles.list}>
              {dataSource.map((item) => (
                <div key={item.id} className={styles.item}>
                  <div className={styles.itemLeft}>
                    <div
                      className={styles.taskName}
                      onClick={() => handleProcess(item)}
                    >
                      {item.title}
                    </div>
                    <div className={styles.itemMeta}>
                      <span>创建人{item.creatorName}</span>
                      <span className={styles.separator}>·</span>
                      <span>
                        截止日期:
                        {item.deadlineTime
                          ? dayjs(item.deadlineTime).format('YYYY-MM-DD')
                          : ''}
                      </span>
                      <span>
                        创建日期:
                        {item.createdTime
                          ? dayjs(item.createdTime).format('YYYY-MM-DD')
                          : ''}
                      </span>
                    </div>
                  </div>
                  <div className={styles.itemRight}>
                    {getUrgentTag(item.priority)}
                    {getStatusTag(item.status)}
                    <Button
                      type="primary"
                      size="large"
                      className={styles.actionBtn}
                      onClick={() => handleProcess(item)}
                    >
                      处理
                    </Button>
                  </div>
                </div>
              ))}
            </div>
            {loadingMore && (
              <div className={styles.loadingMore}>
                <span>加载中...</span>
              </div>
            )}
            {!hasMore && dataSource.length > 0 && (
              <div className={styles.noMore}>
                <span>没有更多数据了</span>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}
